import SuccessfulCustomer from "@/views/Home/components/successfulCustomer.vue";

export default {
  email: "邮箱",
  language: "当前语言",
  currencyLanguage: "CHS(中文)",
  contactUs: "立即咨询",
  services: "服务与支持",
  download: "资料下载",
  more: "了解更多",
  successfulCustomer: "成功客户",
  weChatOfficialAccount: "微信公众号",
  businessDiscussion: "业务接洽",
  leaveAMessage: "请您留言",
  thankMessage:
    "感谢您的关注，如您想咨询任何事宜，请填写以下您的信息，我们会尽快和您联系",
  name: "姓名(必填)",
  phone0: "电话",
  phone: "电话(必填)",
  company: "公司名称(必填)",
  consultingProducts: "咨询产品(备注)",
  submit: "提交",
  home: "主页",
  contactWay: "联系方式",
  characteristic: "特点",
  ICP: "备案号",
  apply: "立即应聘",
  talentRecruitment: "人才招聘",
  history: "发展历史",
  noImage: "暂无图片",
  noData: "暂无数据",

  // 路由--------------------------
  ProductList: "产品中心",
  ProductDetail: "产品详情",
  SolutionPage: "解决方案",
  TechnicalSupport: "服务支持",
  Jobs: "人才招聘",
  News: "新闻中心",
  ContactUs: "联系我们",
  About: "关于Binar Handling",
  DownloadFile: "资料下载",
  ApplicationDetail: "应用",
  Search: "搜索",
  PreviewPdf: "预览",
  DownloadVideo:'视频',
  // ------------------------------
  //jobs
  AllJobs: "全部职位",

  // Mobile----------------------------
  backToMainMenu: "返回主菜单",
  selectLanguage: "选择语言",
  goBack: "返回",
  // ------------------------------------
};
